"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOGIN_ERROR_MESSAGES = exports.LOGIN_ERRORS = exports.AUTH_ERROR_CODES = exports.SESSION_MAX_AGE_DAYS = void 0;
exports.isLoginError = isLoginError;
exports.isSafeReturnTo = isSafeReturnTo;
/** Durata massima di una sessione (DEC-007). */
exports.SESSION_MAX_AGE_DAYS = 7;
/** Codici di errore dell'accesso, nel campo `code` del corpo di errore dell'API. */
exports.AUTH_ERROR_CODES = {
    /** Nessuna sessione valida: cookie assente, scaduto o revocato (401). */
    sessionRequired: 'auth.session_required',
    /** La sessione c'è ma il ruolo non basta (403). */
    forbidden: 'auth.forbidden',
    /** Client OAuth Google non configurato sull'istanza (503). */
    providerNotConfigured: 'auth.provider_not_configured',
};
/**
 * Motivi di rifiuto del login, passati alla pagina di accesso come `?errore=`
 * dal callback OIDC (che può solo reindirizzare).
 */
exports.LOGIN_ERRORS = [
    'non_nel_team',
    'dominio_non_ammesso',
    'account_diverso',
    'scaduto',
    'annullato',
    'provider',
];
exports.LOGIN_ERROR_MESSAGES = {
    non_nel_team: "L'accesso è riuscito ma questo indirizzo non è nel Team di supporto: chiedi all'amministratore di aggiungerti.",
    dominio_non_ammesso: "Puoi entrare solo con l'account Google Workspace aziendale, con l'email verificata. Esci dagli altri account Google e riprova.",
    account_diverso: "L'account Google non è quello registrato per questo indirizzo: chiedi all'amministratore di rimuoverti e riaggiungerti al Team.",
    scaduto: "L'accesso è scaduto: riprova.",
    annullato: "Accesso annullato: non hai confermato l'account su Google. Riprova quando vuoi.",
    provider: 'Google non ha completato l’accesso. Riprova; se il problema persiste avvisa l’amministratore.',
};
/** Vero se `value` è uno dei motivi noti. */
function isLoginError(value) {
    return typeof value === 'string' && exports.LOGIN_ERRORS.includes(value);
}
/**
 * Percorso a cui tornare dopo il login: solo un percorso relativo della web app (`/…`), mai
 * un'origine esterna (`//host`, `http://…`), così il redirect non può portare fuori dalla suite.
 */
function isSafeReturnTo(value) {
    return (typeof value === 'string' &&
        value.length > 0 &&
        value.length <= 2000 &&
        value.startsWith('/') &&
        !value.startsWith('//') &&
        !value.startsWith('/\\'));
}
//# sourceMappingURL=auth.js.map